export const getWidgetText = (enabledForRefunds, enabledForExchanges, Trans) => {
  if (enabledForRefunds && enabledForExchanges) {
    return (
      <Trans i18nKey="reveniWidgetBoth">
        un <strong>cambio</strong> o <strong>devolución</strong>
      </Trans>
    )
  } else if (enabledForRefunds) {
    return (
      <Trans i18nKey="reveniWidgetRefund">
        una <strong>devolución</strong>
      </Trans>
    )
  } else if (enabledForExchanges) {
    return (
      <Trans i18nKey="reveniWidgetExchange">
        un <strong>cambio</strong>
      </Trans>
    )
  }
}
